import api from "@/api";
import type { CreateClipMergeJobRequest, ClipMergeJobResponse } from "@/types/clipVideo";

export const createClipMergeJob = async (request: CreateClipMergeJobRequest): Promise<ClipMergeJobResponse> => {
	return await api.post("/clip-merge-jobs", request);
};

